<template>
  <div class="text-center bg-primary bg-gradient mt-4">
    Copyright © 2023 • Mid City Restaurant Supply • 500 Alakawa St, Honolulu, HI 96817<br>
    <a href="https://www.midcityre.com/policies.cfm">Policies</a> •
    <a href="https://www.midcityre.com/privacy.cfm">Privacy Policy</a><br>
    <a href="http://www.extantware.com/" class="footer-extantware">ExtantWare.com</a>
  </div>
</template>